import { render, staticRenderFns } from "./DespesasPrincipal.vue?vue&type=template&id=b18f0b6a&scoped=true&"
import script from "./DespesasPrincipal.vue?vue&type=script&lang=js&"
export * from "./DespesasPrincipal.vue?vue&type=script&lang=js&"
import style0 from "./DespesasPrincipal.vue?vue&type=style&index=0&id=b18f0b6a&lang=scss&scoped=true&"
import style1 from "./DespesasPrincipal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18f0b6a",
  null
  
)

export default component.exports